module.exports = __webpack_public_path__ + "img/zwischenzeiten1.effc2051.jpg";